
import React from 'react';

interface PaymentModeSelectorProps {
  mode: 'single' | 'installment' | 'fixed';
  setMode: (mode: 'single' | 'installment' | 'fixed') => void;
  installments: string;
  setInstallments: (val: string) => void;
  showRecurrence: boolean;
  isCreditCard: boolean;
}

const PaymentModeSelector: React.FC<PaymentModeSelectorProps> = ({ 
  mode, setMode, installments, setInstallments, showRecurrence, isCreditCard 
}) => {
  if (!showRecurrence) return null;

  return (
    <div className="space-y-1.5">
      <label className="block text-[8px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest ml-1">Modalidade</label>
      <div className="grid grid-cols-3 gap-1.5">
        <button type="button" onClick={() => setMode('single')} className={`py-1.5 rounded-lg text-[7px] font-black uppercase tracking-widest border transition-all ${mode === 'single' ? 'bg-blue-600 border-blue-600 text-white shadow-md' : 'bg-slate-100 dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-500 hover:bg-slate-200'}`}>Único</button>
        <button 
          type="button" 
          disabled={!isCreditCard}
          onClick={() => setMode('installment')} 
          className={`py-1.5 rounded-lg text-[7px] font-black uppercase tracking-widest border transition-all ${mode === 'installment' ? 'bg-blue-600 border-blue-600 text-white shadow-md' : !isCreditCard ? 'bg-slate-50 dark:bg-slate-900/50 border-slate-100 dark:border-slate-800 text-slate-300 cursor-not-allowed opacity-50' : 'bg-slate-100 dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-500 hover:bg-slate-200'}`}
        >
          {isCreditCard ? 'Parcela' : <><i className="fa-solid fa-lock mr-1"></i> Parcela</>}
        </button>
        <button type="button" onClick={() => setMode('fixed')} className={`py-1.5 rounded-lg text-[7px] font-black uppercase tracking-widest border transition-all ${mode === 'fixed' ? 'bg-blue-600 border-blue-600 text-white shadow-md' : 'bg-slate-100 dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-500 hover:bg-slate-200'}`}>Fixo</button>
      </div>

      {mode === 'installment' && (
        <div className="animate-in fade-in slide-in-from-top-1">
          <input 
            type="number" 
            min="2" 
            max="120" 
            value={installments} 
            onChange={(e) => setInstallments(e.target.value)} 
            placeholder="Nº Parcelas"
            className="w-full bg-blue-50 dark:bg-blue-900/20 border-blue-100 dark:border-blue-800 rounded-xl px-4 py-3 text-xs font-black text-blue-700 dark:text-blue-300 outline-none text-center" 
          />
        </div>
      )}
    </div>
  );
};

export default PaymentModeSelector;
